// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2IzjJ","icon":"SortAdornment_icon__NJKNw","up":"SortAdornment_up__3Zp0c","down":"SortAdornment_down__1ZnhA","active":"SortAdornment_active__3QWrH"};